import * as types from './types';
import actions from './actions';
import {
  extend,
  each,
  set
} from 'lodash';

const state = {
  editingCourseManagement: {
    course_name: '',
    course_type: '',
    book_statement_college_id:0
  },
  //结算课程列表
  toolBookStatementCourseList: {
    state : '',
    list : [],
    total : undefined
  },
  //课程用书列表
  toolBookStatementBookCatalogList: {
    state : '',
    list : [],
    total : undefined
  },
  //选择课程用书列表
  toolChangeBookStatementBookCatalogList: {
    state : '',
    list : [],
    total : undefined,
    book_catalog_export_url: null,
  }
};

const getters = {
  //编辑课程
  getEditingCourseManagement: (state) => state.editingCourseManagement,
  getToolBookStatementCourseList: (state) => state.toolBookStatementCourseList,
  getToolBookStatementBookCatalogList: (state) => state.toolBookStatementBookCatalogList,
  getToolChangeBookStatementBookCatalogList: (state) => state.toolChangeBookStatementBookCatalogList,
};

const mutations = {
  [types.EDITING_CHANGE_COURSE_MANAGEMENT]({editingCourseManagement}, result){
    extend(editingCourseManagement, result)
  },
  [types.ACTION_TOOL_BOOK_STATEMENT_COURSE_LIST]({toolBookStatementCourseList}, result){
    extend(toolBookStatementCourseList,result)
  },
  [types.ACTION_TOOL_BOOK_STATEMENT_COURSE_CATALOG_LIST]({toolBookStatementBookCatalogList}, result){
    extend(toolBookStatementBookCatalogList,result)
  },
  [types.ACTION_TOOL_CHANGE_BOOK_STATEMENT_COURSE_LIST]({toolChangeBookStatementBookCatalogList}, result){
    extend(toolChangeBookStatementBookCatalogList,result)
  }
};


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/courseManagement/index.js